<template>
<div class='teacher-verification'>
  <div class='content-header'>
    <p><em>教师认证</em></p>
  </div>
  <p class='content-hint'><i class='ppj-icon-gift'></i>PP匠推出教育发展计划，公立学校老师可以199元购买价值999元的教育专业版（包含50个永久项目额度），助力教育信息化</p>
  <el-form class='content-form' :model="form" :rules="rules" label-width="120px" ref='form'>
    <el-form-item label="真实姓名" prop="realname" :error="errors.first('realname')">
      <el-input v-model="form.realname"></el-input>
    </el-form-item>

    <el-form-item label="所属省份" prop="province" :error="errors.first('province')">
      <el-select v-model="form.province" @change="clearErrors('province')" placeholder="请选择">
        <el-option v-for="prov in provinces" :key="prov.code" :label="prov.name" :value="prov.name">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="任教学校" prop="organization" :error="errors.first('organization')">
      <el-input v-model="form.organization"></el-input>
    </el-form-item>

    <el-form-item label="证件图片" prop="certificate" :error="errors.first('certificate')">
      <ssuploader :url="uploadUrl" :accept="accept" :extensions="extensions" name="verification[certificate]" :data="uploadData" :autoSubmit="false" @change='preview' @complete='complete' ref='uploader' @error='error'>
        <div class='preview-wrapper' :class="{'shrink': !form.certificate}" ref='uploader-btn'>
          <img class='img' ref='preview-image' :alt="form.filename" v-if="supportPreview && form.certificate"></img>
          <div v-else-if="!supportPreview && form.certificate">
            <p>文件名：{{form.filename}}</p>
            <p class='hint'>您的浏览器暂不支持预览图片</p>
          </div>
          <div class='img default' v-else></div>
        </div>
      </ssuploader>
    </el-form-item>

    <el-form-item>
      <p class='hint'>请上传本人教师资格证件，确保照片清晰，四角完整</p>
    </el-form-item>

    <el-form-item>
      <el-button type='primary' @click='save'>提交</el-button>
      <el-button type='text' @click='finish'>取消</el-button>
    </el-form-item>

    <el-form-item>
      <p class='hint' style='white-space: nowrap;'>注意：通过教师认证后，请务必只上传教学相关的内容。如果擅自用于商业用途，一经发现，平台将取消优惠资格，按正常价格核算额度。</p>
    </el-form-item>
  </el-form>
</div>
</template>

<script>
import provinces from '@/config/data/provinces.json'
import validator from '@/mixins/validator'
import SSUploader from '@/components/widgets/ss_uploader.input'

export default {
  data() {
    return {
      form: {
        realname: null,
        province: null,
        organization: null,
        certificate: null,
        filename: null
      },
      provinces: provinces,
      supportPreview: true,
      // route related
      pathFrom: null,
      // uploader related
      uploadUrl: `${process.env.API_ROOT}occupation_verification`,
      accept: '.png, .gif, .jpeg, .jpg, image/*',
      extensions: ['png', 'gif', 'jpeg', 'jpg']
    }
  },
  mixins: [validator],
  rules: {
    required: ['realname', 'province', 'organization', 'certificate']
  },
  components: {
    'ssuploader': SSUploader
  },
  computed: {
    uploadData() {
      return {
        'verification[realname]': this.form.realname,
        'verification[province]': this.form.province,
        'verification[organization]': this.form.organization
      }
    }
  },
  methods: {
    preview(params) {
      let vm = this

      vm.clearErrors('certificate')
      vm.form.certificate = params.file
      vm.form.filename = params.filename

      try {
        let reader = new FileReader()
        reader.addEventListener('load', function() {
          vm.$refs['preview-image'].src = reader.result
        }, false)
        if (vm.form.certificate) {
          reader.readAsDataURL(vm.form.certificate)
        }
      } catch (e) {
        vm.supportPreview = false
      }
    },
    save() {
      let vm = this
      let p1 = new Promise((resolve, reject) => {
        vm.$refs['form'].validate(res => {
          res ? resolve() : reject('form')
        })
      })

      p1.then(_ => {
        // after validator
        vm.$refs['uploader'].submit()
      }).catch(_ => {})
    },
    complete() {
      let vm = this
      vm.$store.dispatch('refresh')
      this.$alert('认证成功，您已获得1折购买教育专业版的优惠。', '恭喜', {
        callback: () => {
          this.$router.push('/order?type=edu')
        }
      })
    },
    finish() {
      this.$router.push((this.pathFrom && this.pathFrom.path) || '/profile')
    },
    error(res) {
      if (parseInt(res.status) === 400) {
        this.$router.push('/order?type=edu')
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from && from.path !== '/') {
        vm.pathFrom = from
      }
    })
  }
}
</script>

<style lang='scss'>
.teacher-verification {
    width: $page-width-small;
    min-height: $min-height-base;
    background-color: $color-white-base;
    margin: $margin-base auto 0;
    box-shadow: $box-shadow-base;
    padding: 0 $margin-base $margin-base;

    .content-header {
        overflow: hidden;
        border-bottom: $border-base;
        color: $font-color-strong;
        em {
            font-style: normal;
        }

        .hint {
            font-size: $font-size-small;
            vertical-align: bottom;
            padding-top: $font-size-base - $font-size-small;
        }
    }

    .content-hint {
        color: $color-primary;
        padding-left: 40px;
        margin: 2em 0;

        .ppj-icon-gift {
            margin-right: 0.4em;
        }
    }

    .content-form {
        margin: $margin-base;
        width: 400px;

        $preview-size: 160px;
        $preview-default-ratio: 1.4; // w/h
        .preview-wrapper {
            min-width: $preview-size;
            &.shrink {
                width: $preview-size;
            }
            .img {
                background-size: contain;
                &.default {
                    width: $preview-size;
                    height: $preview-size / $preview-default-ratio;
                    margin-left: 0;
                    background-image: url("~@/assets/images/image-uploader-default.png");
                }
            }
        }

        .hint {
            line-height: 1;
        }
    }
}
</style>



// WEBPACK FOOTER //
// teacher_verification.vue?3d35014d